import React, { memo, useContext, Fragment } from 'react';

import { ContextPanel } from '@atlaskit/editor-core';

import {
	useIsObjectSidebarShown,
	usePanelWidth,
	usePanel,
	MIN_PANEL_WIDTH,
} from '@confluence/object-sidebar-api/entry-points/useObjectSidebar';
import { useAIRovoButtonEnablement } from '@confluence/ai-floating-context-menu/entry-points/useAIRovoButtonEnablement';
import { fg } from '@confluence/feature-gating';
import { ObjectSidebarPanel } from '@confluence/object-sidebar-components/entry-points/ObjectSidebarPanelWrapper';
import { EditorContextPanelContext } from '@confluence/editor-context-panel/entry-points/EditorContextPanelContext';

export const EditorContextPanelView = memo(() => {
	const isObjectSidebarShown = useIsObjectSidebarShown();
	const isRovoButtonEnabled = useAIRovoButtonEnablement();
	const panelWidth = usePanelWidth();
	const panel = usePanel();

	const { item: contextPanelItem, editorAPI } = useContext(EditorContextPanelContext);

	// Previously, the pattern was to set state in EditorContextPanelContext in order to render components here.
	// Now, we render components directly in EditorContextPanelView to avoid bugs like https://hello.jira.atlassian.cloud/browse/DISCO-4183
	if (isObjectSidebarShown && (fg('confluence_frontend_content_wrapper') || isRovoButtonEnabled)) {
		return (
			<ContextPanel
				visible
				editorAPI={editorAPI ?? undefined}
				hasPadding={false}
				customWidth={
					(panel?.id === 'proactive-ai-panel' ||
						(panel?.id.startsWith && panel?.id.startsWith('extensions-panel')) ||
						panel?.id === 'editor-element-insert-sidebar-panel') &&
					fg('platform_editor_ai_object_sidebar_injection')
						? panelWidth || MIN_PANEL_WIDTH
						: MIN_PANEL_WIDTH
				}
			>
				<ObjectSidebarPanel />
			</ContextPanel>
		);
	}

	let component;
	let hasPadding;
	let customWidth;

	if (contextPanelItem) {
		component = contextPanelItem.component;
		hasPadding = contextPanelItem.hasPadding;
		customWidth = contextPanelItem.customWidth;
	}

	return (
		<ContextPanel
			visible={!!contextPanelItem}
			editorAPI={editorAPI ?? undefined}
			hasPadding={hasPadding}
			customWidth={customWidth}
		>
			<Fragment>{component}</Fragment>
		</ContextPanel>
	);
});
